import { render, staticRenderFns } from "./bodyList.vue?vue&type=template&id=56194a2e&scoped=true"
import script from "./bodyList.vue?vue&type=script&lang=js"
export * from "./bodyList.vue?vue&type=script&lang=js"
import style0 from "./bodyList.vue?vue&type=style&index=0&id=56194a2e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56194a2e",
  null
  
)

export default component.exports